"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getObjectCustomFields = exports.getObjectTagFieldName = exports.isObjectList = exports.extractActivityOrListSchema = void 0;
const types_1 = require("../../types");
const extractActivityOrListSchema = (object, includeMatrixOnListQuestions // by default not.
) => {
    const tagFieldName = (0, exports.getObjectTagFieldName)(object);
    // we return the questions/attributes excluding the matrix on list questions/attributes (will be treated separately)
    const customFields = (0, exports.getObjectCustomFields)(object);
    return customFields
        .filter((q) => !(q === null || q === void 0 ? void 0 : q.deprecated))
        .filter((q) => q.type !== types_1.CUSTOM_FIELD_TYPE.MATRIX_ON_LIST ||
        includeMatrixOnListQuestions)
        .map((q) => ({
        tag: q[tagFieldName],
        type: q.type,
        listId: q.list_id,
        isUnique: q.is_unique,
        otherProps: {
            options: q.options,
            matrix: q.matrix
        }
    }));
};
exports.extractActivityOrListSchema = extractActivityOrListSchema;
const isObjectList = (object) => {
    return object && "schema" in object ? true : false;
};
exports.isObjectList = isObjectList;
const getObjectTagFieldName = (object) => {
    const isList = (0, exports.isObjectList)(object);
    return isList ? "column_tag" : "tag";
};
exports.getObjectTagFieldName = getObjectTagFieldName;
const getObjectCustomFields = (object) => {
    const isList = (0, exports.isObjectList)(object);
    const customFields = isList
        ? object.schema
        : object.questionnaire.questions;
    return customFields;
};
exports.getObjectCustomFields = getObjectCustomFields;
